module.exports = __webpack_public_path__ + "static/media/healthbuzzdefault.c80de19d.jpg";